import React, { useState, useEffect, useRef } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { green } from "@material-ui/core/colors";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import { Stack } from "@mui/material";
import { toast } from "react-toastify";

const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    flexWrap: "wrap"
  },
  textField: {
    marginRight: theme.spacing(1),
    flex: 1
  },
  btnWrapper: {
    position: "relative"
  },
  buttonProgress: {
    color: green[500],
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12
  }
}));

const FlowBuilderCloseTicketModal = ({ open, onSave, onUpdate, data, close }) => {
  const classes = useStyles();
  const isMounted = useRef(true);

  const [activeModal, setActiveModal] = useState(false);
  const [labels, setLabels] = useState({
    title: "Adicionar Fechamento Ticket",
    btn: "Adicionar"
  });

  const [message, setMessage] = useState("");
  const [timeValue, setTimeValue] = useState("");
  const [timeUnit, setTimeUnit] = useState("seconds");

  const parseFromSeconds = (valueStr, unitStr) => {
    const v = parseInt(String(valueStr), 10);
    const n = isNaN(v) || v <= 0 ? 0 : v;
    switch (unitStr) {
      case "minutes":
        return n / 60;
      case "hours":
        return n / 3600;
      case "days":
        return n / 86400;
      default:
        return n;
    }
  };

  useEffect(() => {
    if (open === "edit") {
      setLabels({
        title: "Editar Fechamento Ticket",
        btn: "Salvar"
      });
      const msg = data?.data?.message ?? "";
      const timer = data?.data?.timer ?? "";
      const unit = data?.data?.unit ?? "seconds";
      setMessage(String(msg));
      setTimeValue(timer !== "" && timer !== undefined ? String(parseFromSeconds(timer, unit)) : "");
      setTimeUnit(unit);
      setActiveModal(true);
    } else if (open === "create") {
      setLabels({
        title: "Adicionar Fechamento Ticket",
        btn: "Adicionar"
      });
      setMessage("");
      setTimeValue("");
      setTimeUnit("seconds");
      setActiveModal(true);
    } else {
      setActiveModal(false);
    }
  }, [open, data]);

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  const handleClose = () => {
    close(null);
    setActiveModal(false);
  };

  const parseToSeconds = (valueStr, unitStr) => {
    const v = parseInt(String(valueStr), 10);
    const n = isNaN(v) || v <= 0 ? 0 : v;
    switch (unitStr) {
      case "minutes":
        return n * 60;
      case "hours":
        return n * 3600;
      case "days":
        return n * 86400;
      default:
        return n;
    }
  };

  const handleSave = () => {
    const v = parseInt(String(timeValue), 10);
    if (isNaN(v) || v <= 0) {
      toast.error("Informe um tempo válido maior que zero.");
      return;
    }
    if (!message || message.trim() === "") {
      toast.error("Informe a mensagem de encerramento.");
      return;
    }
    const timerSeconds = parseToSeconds(timeValue, timeUnit);
    if (open === "edit") {
      onUpdate({
        ...data,
        data: {
          ...data.data,
          message,
          timer: timerSeconds,
          unit: timeUnit,
          isCloseTicket: true
        }
      });
      handleClose();
      return;
    } else if (open === "create") {
      onSave({
        message,
        timer: timerSeconds,
        unit: timeUnit,
        isCloseTicket: true
      });
      handleClose();
    }
  };

  return (
    <div className={classes.root}>
      <Dialog open={activeModal} onClose={handleClose} fullWidth="md" scroll="paper">
        <DialogTitle id="form-dialog-title">{labels.title}</DialogTitle>
        <Stack>
          <DialogContent dividers>
            <Stack direction="row" spacing={2} style={{ marginTop: 12, width: "95%" }}>
              <TextField
                label={"Tempo sem interação"}
                variant="outlined"
                value={timeValue}
                onChange={e => {
                  const val = e.target.value.replace(/[^0-9]/g, "");
                  setTimeValue(val);
                }}
                className={classes.textField}
              />
              <FormControl variant="outlined" style={{ minWidth: 160 }}>
                <InputLabel>Unidade</InputLabel>
                <Select
                  label="Unidade"
                  value={timeUnit}
                  onChange={e => setTimeUnit(e.target.value)}
                >
                  <MenuItem value="seconds">Segundos</MenuItem>
                  <MenuItem value="minutes">Minutos</MenuItem>
                  <MenuItem value="hours">Horas</MenuItem>
                  <MenuItem value="days">Dias</MenuItem>
                </Select>
              </FormControl>
            </Stack>
            <TextField
              label={"Mensagem de encerramento"}
              multiline
              rows={6}
              variant="outlined"
              value={message}
              margin="dense"
              onChange={e => setMessage(e.target.value)}
              className={classes.textField}
              style={{ width: "95%", marginTop: "10px" }}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="secondary" variant="outlined">
              Cancelar
            </Button>
            <Button
              type="submit"
              color="primary"
              variant="contained"
              className={classes.btnWrapper}
              onClick={handleSave}
            >
              {labels.btn}
            </Button>
          </DialogActions>
        </Stack>
      </Dialog>
    </div>
  );
};

export default FlowBuilderCloseTicketModal;
